<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <v-btn
          block
          min-height="200px"
          :outlined="contractorOutlined"
          color="primary"
          style="font-size: 30px"
          :disabled="contractorDisabled"
          @click="contractorClickedHandler"
        >
          Contractor
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn
          block
          min-height="200px"
          :outlined="permPlacementOutlined"
          color="primary"
          style="font-size: 30px"
          :disabled="permPlacementDisabled"
          @click="permPlacementClickedHandler"
        >
          Permanent<br>Placement
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="6" md="3" class="pl-2" v-if="!!dealAssignmentType">
        <v-btn
          block
          color="primary"
          depressed
          @click="nextStep"
        >
          Next
        </v-btn>
      </v-col>
      <v-col cols="6" md="3" class="pl-2">
        <v-btn
          block
          outlined
          depressed
          @click="goBack"
        >
          {{ backButtonLabel }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ButtonsSubmitForm } from '@/components/buttons'
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { CONTRACTOR, PERMANENT_PLACEMENT } from '@/lib/constants/dealAssignmentTypes'
import { CREATE_FROM_ZOHO } from '@/lib/constants/dealCreationTypes'
import { dealsRoute } from '@/lib/constants/routes'

export default {
  props: [
    'readonly'
  ],
  components: {
    ButtonsSubmitForm
  },
  data () {
    return {
      isFormValid: null,
      dealId: null,
      contractorOutlined: true,
      permPlacementOutlined: true,
      contractorDisabled: false,
      permPlacementDisabled: false,
      CONTRACTOR,
      PERMANENT_PLACEMENT,
      CREATE_FROM_ZOHO
    }
  },
  computed: {
    ...mapFields('deal', ['id', 'statusId', 'dealAssignmentType', 'dealCreationTypeId']),
    ...mapFields('settings', ['zohoIntegrationSettings']),
    backButtonLabel () {
      return this.zohoIntegrationSettings.integrationEnabled ? 'Back' : 'Cancel'
    }
  },
  methods: {
    ...mapActions('deal', ['saveDeal']),
    contractorClickedHandler () {
      if (!this.readonly) {
        this.contractorOutlined = false
        this.permPlacementOutlined = true
        this.dealAssignmentType = CONTRACTOR
        if (this.dealCreationTypeId !== CREATE_FROM_ZOHO) {
          this.nextStep()
        }
      }
    },
    permPlacementClickedHandler () {
      if (!this.readonly) {
        this.contractorOutlined = true
        this.permPlacementOutlined = false
        this.dealAssignmentType = PERMANENT_PLACEMENT
        if (this.dealCreationTypeId !== CREATE_FROM_ZOHO) {
          this.nextStep()
        }
      }
    },
    nextStep () {
      if (!this.readonly && this.dealCreationTypeId !== CREATE_FROM_ZOHO) {
        this.saveDeal().then(() => {
          this.$emit('complete')
          this.disableButtons()
        })
      } else {
        this.$emit('complete')
      }
    },
    goBack () {
      if (this.zohoIntegrationSettings.integrationEnabled) {
        this.$emit('goBack')
      } else {
        this.$router.push({ name: dealsRoute.name })
      }
    },
    disableButtons () {
      if (this.dealAssignmentType === CONTRACTOR) {
        this.contractorOutlined = false
        this.permPlacementDisabled = true
      }
      if (this.dealAssignmentType === PERMANENT_PLACEMENT) {
        this.permPlacementOutlined = false
        this.contractorDisabled = true
      }
    }
  }
}
</script>
